/**
 * Show a cancel confirmation
 * @param {Object} ModalComponent
 * @param {Object} StateUtils
 * @returns {Function}
 */
export default function (ModalComponent, StateUtils) {
    return function (model, _ref) {
        var title = _ref.title,
            message = _ref.message;

        title = title || 'platform.flow.angularhelpers.CancelConfirmation.Are you sure you want to cancel?';
        message = message || 'platform.flow.angularhelpers.CancelConfirmation.The information previously entered will be stored as a draft';

        var validModel = model && model.aspects && model.aspects.valid && model.aspects.subtreeValid ? model : StateUtils.activeDataForState(true).flowModel.snapshot;
        var cancelConfirmedPromise = ModalComponent.showWarning(title, message).result;

        return cancelConfirmedPromise.then(function () {
            return validModel;
        });
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/flow/angularhelpers/CancelConfirmation.js
// module id = 154
// module chunks = 0